import { FC } from 'react'

import FormikField from '../../form/FormikField'
import { FormikFormProps } from '../../form/FormikForm'
import { FormFieldInputProps } from '../../form/fields/FormFieldInput'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { FormSubmitButtonProps } from '../../form/FormSubmitButton'
import FormMessages, { FormMessagesProps } from '../../form/FormMessages'
import { FormFieldEmailProps } from '../../form/fields/FormFieldEmail'
import { FormFieldOrientation } from '../../types/form'

import * as SC from './styled'

type LoginFormValues = {
  email: string
  password: string
}

export type LoginFormProps = FormikFormProps<LoginFormValues> & {
  fields: {
    email: Omit<FormFieldEmailProps, 'name'>
    password: Omit<FormFieldInputProps, 'name' | 'type'>
  }
  forgottenButton?: FormSubmitButtonProps
  submitButton?: FormSubmitButtonProps
  errors?: FormMessagesProps['messages']
}

const LoginForm: FC<LoginFormProps> = ({
  fields,
  submitButton,
  forgottenButton,
  errors,
  ...formikProps
}) => {
  const { email, password } = fields

  return (
    <SC.Container>
      <SC.Form {...formikProps}>
        <SC.Fields>
          <FormikField
            labelProps={{ underlined: true }}
            orientation={FormFieldOrientation.Horizontal}
            {...email}
            name="email"
            Component={SC.EmailField}
          />
          <FormikField
            labelProps={{ underlined: true }}
            orientation={FormFieldOrientation.Horizontal}
            name="password"
            type="password"
            {...password}
            Component={SC.TextField}
          />
        </SC.Fields>
        {errors && <FormMessages messages={errors} />}
        <SC.Actions>
          <SC.ForgottenButton
            variant={ActionButtonVariant.secondary}
            {...forgottenButton}
          />
          <SC.SubmitButton
            type={'submit'}
            variant={ActionButtonVariant.quaternary}
            {...submitButton}
          />
        </SC.Actions>
      </SC.Form>
    </SC.Container>
  )
}

export default LoginForm
